import React from "react";
import { Link } from "react-router-dom";

import { ROUTES } from "../../data/content";
import PageMeta from "./PageMeta";
import PageBanner from "./PageBanner";

const NotFound = () => {
  return (
    <React.Fragment>
      <PageBanner />
      <section className={"not-found"}>
        <PageMeta
          title={"Page not found"}
          noIndex
        />
        <h1 className={"page-title"}>Page not found</h1>
        <p>The page you&apos;re looking for doesn&apos;t exist or has moved.</p>
        <Link
          to={ROUTES.HOME}
          className={"btn"}
        >
          Back to home
        </Link>
      </section>
    </React.Fragment>
  );
};

export default NotFound;
